/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressDto } from './AddressDto';
import type { OffenseOrderInfoDto } from './OffenseOrderInfoDto';
import type { OffenseTypeSimpleDto } from './OffenseTypeSimpleDto';
/**
 * Offense
 */
export type OffenseDto = {
    /**
     * Offense identifier. Type: "UUID"
     */
    id: string;
    /**
     * Offense variable symbol
     */
    variableSymbol: string;
    /**
     * Customer checked at
     */
    checkedAt: string;
    /**
     * Transport line
     */
    line?: string;
    /**
     * Transport connection
     */
    connection?: string;
    /**
     * Transport train number
     */
    train?: string;
    /**
     * Inspector identifier
     */
    inspectorId: string;
    /**
     * Customer name
     */
    customerName: string;
    /**
     * Customer birth day
     */
    customerBirthDay: string;
    /**
     * Offense state
     */
    state: OffenseDto.state;
    /**
     * Pay by date
     */
    payBy: string;
    /**
     * Amount to pay
     */
    amountToPay: number;
    /**
     * Customer address
     */
    address: AddressDto;
    /**
     * Delivery address
     */
    deliveryAddress: AddressDto;
    /**
     * Offense type
     */
    offenseType: OffenseTypeSimpleDto;
    /**
     * Offense order info
     */
    orderInfo?: OffenseOrderInfoDto;
};
export namespace OffenseDto {
    /**
     * Offense state
     */
    export enum state {
        PENDING = 'PENDING',
        PAID = 'PAID',
        REJECTED = 'REJECTED',
    }
}

